import React, { useState, useEffect } from "react";
import Login from "./pages/Login";
import Main  from "./pages/Main";

/**
 * App.js
 * ──────
 * Root component.  Auth is now backed by PostgreSQL via the FastAPI server.
 * Logic is otherwise identical to the static-JSON version.
 */
function App() {
  // Restore previous session on page refresh
  const savedRole = sessionStorage.getItem("auth_role"); // "admin" | "fleet" | "vessel" | null

  const [role, setRole] = useState(savedRole || null);

  // Sync role to sessionStorage
  useEffect(() => {
    if (role) {
      sessionStorage.setItem("auth_role", role);
    } else {
      // Clear all auth session keys on logout
      sessionStorage.removeItem("auth_role");
      sessionStorage.removeItem("auth_fleet_key");
      sessionStorage.removeItem("auth_fleet_info");
      sessionStorage.removeItem("auth_vessel_key");
      sessionStorage.removeItem("auth_vessel_info");
    }
  }, [role]);

  const handleLogin  = (userRole) => setRole(userRole);
  const handleLogout = ()         => setRole(null);

  if (!role) {
    return <Login onLogin={handleLogin} />;
  }

  return (
    <Main
      initialRole={role}
      onLogout={handleLogout}
    />
  );
}

export default App;